export const FileUpload = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59961 26.9001C9.59961 26.5819 9.72604 26.2766 9.95108 26.0516C10.1761 25.8266 10.4813 25.7001 10.7996 25.7001H25.1996C25.5179 25.7001 25.8231 25.8266 26.0481 26.0516C26.2732 26.2766 26.3996 26.5819 26.3996 26.9001C26.3996 27.2184 26.2732 27.5236 26.0481 27.7487C25.8231 27.9737 25.5179 28.1001 25.1996 28.1001H10.7996C10.4813 28.1001 10.1761 27.9737 9.95108 27.7487C9.72604 27.5236 9.59961 27.2184 9.59961 26.9001ZM13.5512 14.5485C13.3262 14.3235 13.1999 14.0183 13.1999 13.7001C13.1999 13.3819 13.3262 13.0768 13.5512 12.8517L17.1512 9.25173C17.3762 9.02677 17.6814 8.90039 17.9996 8.90039C18.3178 8.90039 18.623 9.02677 18.848 9.25173L22.448 12.8517C22.6666 13.0781 22.7876 13.3812 22.7848 13.6958C22.7821 14.0105 22.6559 14.3114 22.4334 14.5339C22.2109 14.7564 21.9099 14.8826 21.5953 14.8853C21.2807 14.8881 20.9775 14.7671 20.7512 14.5485L19.1996 12.9969V22.1001C19.1996 22.4184 19.0732 22.7236 18.8481 22.9487C18.6231 23.1737 18.3179 23.3001 17.9996 23.3001C17.6813 23.3001 17.3761 23.1737 17.1511 22.9487C16.926 22.7236 16.7996 22.4184 16.7996 22.1001V12.9969L15.248 14.5485C15.023 14.7735 14.7178 14.8999 14.3996 14.8999C14.0814 14.8999 13.7762 14.7735 13.5512 14.5485Z"
        fill="currentColor"
      />
    </svg>
  );
};
